function isProdBuild() {
  return process.env.NODE_ENV === 'production';
}

function isDevBuild() {
  return !isProdBuild();
}

const env = {
  isDev: isDevBuild,
  isStaging: () => process.env.REACT_APP_BUILD_TYPE === 'stage',
  isPreprod: () => process.env.REACT_APP_BUILD_TYPE === 'pre-prod',
  isProd: () => process.env.REACT_APP_BUILD_TYPE === 'prod',
};

export default env;
